import { GspCommonField } from '../../ref';
import { VariableSourceType } from './VariableSourceType';

/**
 * 变量定义
 * @author wangjiegj<wangjiegj@inspur.com>
 */


/**
 * 变量定义
 */
export class CommonVariable extends GspCommonField {

  /**
   * 变量来源
   */
  VariableSourceType: VariableSourceType;

}
